import { useGetCurrentUserQuery } from "@/shared/services";
import { useAppSelector } from "@store";
import { getSettings } from "@store/story/selectors";
import { useEffect, useState } from "react";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { Main } from "./Main";

export const Wrapper = () => {
  const { data: user } = useGetCurrentUserQuery();
  const settings = useAppSelector(getSettings);
  const [selected, setSelected] = useState<"all" | "mentions" | "none">(
    "mentions",
  );

  useEffect(() => {
    if (!user) return;
    const notificationSettings = settings?.notificationSettings || {};
    const selected = notificationSettings[user._id] || "mentions";
    setSelected(selected);
  }, [user, settings]);

  return (
    <div className="tw-w-[538px]">
      <Header />
      <Main selected={selected} setSelected={setSelected} />
      <Footer selected={selected} id={user?._id || ""} />
    </div>
  );
};
